<template>
  <div class="load-cell">
    <div v-if="!record.isSumRow && record.postCode !== 'driver' && !record.loadType.is_system" class="load-cell-value load-cell-value-hover">
      <c-input v-model="localCellLocalValue" class="load-cell-value-input" placeholder="0" type="price-number" />
    </div>
    <div v-else class="load-cell-value">{{ record.load.value }}</div>
    <div class="load-cell-unit">{{ record.load.unit }}</div>
  </div>
</template>
<script>
import Input from "@/components/controls2/Input";

export default {
  name: "load-cell",
  components: {
    "c-input": Input,
  },
  props: ["record"],
  data() {
    return {
      localCellLocalValue: 0,
    };
  },
  watch : {
    "localCellLocalValue" : function (v) {
      if (this.record.isShowRow || this.record.loadType.is_system || this.record.isSumRow || this.record.postCode === 'driver') return false;
      v = parseFloat(v);
      if (!isNaN(v)) {
        this.$emit("loadvalue", {code:this.record.postCode, v:v});
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.localCellLocalValue = this.record.load.value;
    }, 300);
  },
};
</script>
<style lang="scss" scoped>
.load-cell {
  display: flex;
  align-items: center;
  line-height: 13px;
  font-size: 13px;
  height: 100%;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  &-value {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 65%;
    padding: 10px !important;
    text-align: right;
    border-right: 1px solid #dfe4ef;

    &-hover {
      &:active,
      &:hover {
        outline-style: solid;
        outline-width: 1px !important;
        outline-color: #0066ff !important;
        box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
      }
    }

    &-input {
      display: flex;
      align-items: center;
      max-width: 100px;
      width: 100%;
      height: 100%;

      &::v-deep .c-input-border {
        display: none;
      }

      &::v-deep .c-input-input {
        font-size: 13px;
        text-align: right;
        min-height: 15px;
        padding: 0 !important;
      }
    }
  }

  &-unit {
    display: flex;
    height: 100%;
    align-items: center;
    min-width: 35px;
    width: 35%;
    padding: 10px !important;
    text-align: left;
  }
}
</style>
